<template>
  <v-main>
    <v-container>
      <v-card elevation="6">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Update Supplier
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.name"
                outlined
                label="Name *"
                prepend-inner-icon="mdi-account"
                :error-messages="errors.name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone_no"
                outlined
                label="Phone *"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone_no"
              ></v-text-field
            ></v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.email"
                outlined
                label="Email *"
                prepend-inner-icon="mdi-email"
                :error-messages="errors.email"
              ></v-text-field
            ></v-col>

            <v-col sm="4">
              <v-autocomplete
                ref="currency"
                v-model="form.currency_id"
                :items="currencyItems"
                @change="getSubCategory"
                label="Select Currency"
                prepend-inner-icon="mdi-ferry"
                outlined
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-progress-circular
            v-if="isLoading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-btn v-else color="primary" dark @click="save">
            Update Supplier
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "SupplierEditPage",
  data() {
    return {
      form: {
        name: "",
        email: "",
        currency_id: "",
      },
      currencyItems: [],
      isLoading: false,
    };
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("suppliers/masters");
      masters = masters.data;
      masters.currencies.forEach((currency) => {
        this.currencyItems.push({
          id: currency.id,
          text: currency.description,
          value: currency.id,
        });
      });
    },
    async getData() {
      this.isLoading = true;
      let form = await axios.get(`/suppliers/${this.$route.params.supplierId}`);
      this.form = form.data.data;
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        await axios.post(`/suppliers`, this.form);
        this.isLoading = false;
        this.$router.push("/suppliers");
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
